type Address = {
    country: string | null;
    city: string | null;
    state: string | null;
};

export const getDisplayLocation = (address?: Address | null): string => {
    const { country, city, state } = address || {};

    const outputSegments = [];

    if (city) {
        outputSegments.push(city);
        if (country === 'US' && state) {
            outputSegments.push(state);
        }
    } else if (state) {
        outputSegments.push(state);
    }

    if (outputSegments.length <= 1 && country) {
        outputSegments.push(country);
    }

    return outputSegments.join(', ');
};
